import { c as _c } from "react/compiler-runtime";
import React from 'react';
import LargeImageOverlapText, { LargeImageOverlapTextConfigPropType } from 'components/consumer/large-image-overlap-text';
const FeaturedBlog = t0 => {
  const $ = _c(3);
  const {
    config
  } = t0;
  if (!config) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      heading: "pl-10"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== config) {
    t2 = <div className="[&_img]:min-w-[200px]"><LargeImageOverlapText lazy={false} config={{
        ...config,
        additionalClasses: t1
      }} /></div>;
    $[1] = config;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
FeaturedBlog.propTypes = {
  config: LargeImageOverlapTextConfigPropType
};
export default React.memo(FeaturedBlog);